export default __webpack_public_path__ + "b8c48ae6050f7656f1b328671af6cf69.webp";